import Action from './Action.connect';

export default Action;
